import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffectsStickerSkin = {
  ...textEffectsSharedSkin,
  'text-effects-color-1': {
    type: 'COLOR',
  },
  'text-effects-color-2': {
    type: 'COLOR',
  },
  'text-effects-color-3': {
    type: 'COLOR',
  },
  'text-effects-color-4': {
    type: 'COLOR',
  },
  'text-effects-color-5': {
    type: 'COLOR',
  },
  'text-effects-color-6': {
    type: 'COLOR',
  },
  'text-effects-color-7': {
    type: 'COLOR',
  },
  'outer-stroke': {
    type: 'NUMBER',
    defaultValue: '20',
  },
  'bevel-angle': {
    type: 'CSSString',
    defaultValue: '45deg',
  },
  'gradient-center': {
    type: 'CSSString',
    defaultValue: '50%',
  },
  'top-gradient': {
    type: 'CSSString',
    defaultValue: '50%',
  },
  'bottom-gradient': {
    type: 'CSSString',
    defaultValue: '50%',
  },
  'text-stroke': {
    type: 'NUMBER',
    defaultValue: '20',
  },
  'shadow-angle': {
    type: 'CSSString',
    defaultValue: '45deg',
  },
  'shadow-blur': {
    type: 'NUMBER',
    defaultValue: '10',
  },
  'shadow-distance': {
    type: 'NUMBER',
    defaultValue: '50',
  },
  'shadow2-angle': {
    type: 'CSSString',
    defaultValue: '135deg',
  },
  'shadow2-distance': {
    type: 'NUMBER',
    defaultValue: '50',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffectsStickerSkinDefinitionMap: Record<
  string,
  SiteAssetsSkinParams
> = {
  'wixui.skins.TextEffectsSticker': TextEffectsStickerSkin,
};

export default generateSkinDefaults(TextEffectsStickerSkinDefinitionMap);
